module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (!_vm.channels.length) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v("No sales data yet")]) : [_c('div', {
    staticClass: "donut-row"
  }, [_c('div', {
    staticClass: "donut-wrap"
  }, [_c('canvas', {
    ref: "canvas"
  })]), _vm._v(" "), _c('div', {
    staticClass: "channel-list"
  }, _vm._l((_vm.channels), function(ch) {
    return _c('div', {
      key: ch.name,
      staticClass: "channel-item"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('span', {
      staticClass: "swatch",
      style: ({
        background: ch.color
      })
    }), _vm._v(_vm._s(ch.name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "pct"
    }, [_vm._v(_vm._s(ch.pct) + "%")])])
  }), 0)])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-head"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Sale Channels")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-e2bbb26c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2bbb26c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/channelMix.vue
// module id = 3002
// module chunks = 0